import { render } from "./App.vue?vue&type=template&id=7ba5bd90"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7ba5bd90&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ba5bd90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ba5bd90', __exports__)) {
    console.log('reload')
    api.reload('7ba5bd90', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=7ba5bd90", () => {
    console.log('re-render')
    api.rerender('7ba5bd90', render)
  })

}


export default __exports__